import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { sizeClassName } from '../../classNameStrategies';
export default function videoComponentWrapper(ExternalComponent) {
    var _React_Component, _VideoComponentWrapper;
    return withDimensions((_VideoComponentWrapper = class VideoComponentWrapper extends (_React_Component = React.Component) {
        render() {
            const { componentData: { config, data }, width } = this.props;
            return /*#__PURE__*/ React.createElement(ExternalComponent, {
                config: config,
                data: data,
                width: width
            });
        }
        constructor(props){
            super(props);
            _define_property(this, "handleFilesAdded", (data)=>{
                this.props.store.update('componentData', {
                    data
                });
            });
            if (props.store) {
                props.store.set('handleFilesAdded', this.handleFilesAdded.bind(this));
            }
        }
    }, _define_property(_VideoComponentWrapper, "sizeClassName", (componentData, theme, styles, isMobile)=>sizeClassName(componentData, theme, styles, isMobile)), _VideoComponentWrapper));
}

//# sourceMappingURL=video-component-wrapper.js.map